// extracted by mini-css-extract-plugin
module.exports = {"inputBox":"style_inputBox__v9zCl","customLabel":"style_customLabel__3eHWz"};